import type { Distributor } from './eto-app';

function DistributorCard({ componentName, distributorCardLoading, distributorInfo, userLocation, openContactDialog, LS, i18n }: {
    componentName: string;
    distributorCardLoading: boolean;
    distributorInfo: Distributor[];
    userLocation: string | null;
    openContactDialog: (distributor: Distributor) => void;
    LS: any;
    i18n: (key: string) => string;
}) {
    const PARTNER_LOCATOR_URL = 'https://www.rockwellautomation.com/en-us/sales/partner-locator.html';

    return (
        <div className={`${componentName}__distributor-card`}>
            {distributorCardLoading && (
                <div className={`${componentName}__distributor-card-skeleton`}>
                    <div className={`${componentName}__skeleton-top-section`}>
                        <div className={`${componentName}__distributor-card-skeleton-header`}>
                            <div className={`${componentName}__distributor-card-skeleton-title ${componentName}__loading-animation`}></div>
                            <div className={`${componentName}__distributor-card-skeleton-subtitle ${componentName}__loading-animation`}></div>
                            <div className={`${componentName}__distributor-card-skeleton-desc ${componentName}__loading-animation`}></div>
                        </div>
                    </div>
                    <div className={`${componentName}__distributor-card-skeleton-line`}></div>
                    <div className={`${componentName}__distributor-card-skeleton-content`}>
                        <div className={`${componentName}__distributor-card-skeleton-details ${componentName}__loading-animation`}></div>
                        <div className={`${componentName}__distributor-card-skeleton-icons`}>
                            <div className={`${componentName}__distributor-card-skeleton-icon ${componentName}__loading-animation`}></div>
                            <div className={`${componentName}__distributor-card-skeleton-icon ${componentName}__loading-animation`}></div>
                        </div>
                    </div>
                    <div className={`${componentName}__distributor-card-skeleton-line`}></div>
                    <div className={`${componentName}__skeleton-distributor-bottom-section`}>
                        <div className={`${componentName}__distributor-card-skeleton-desc ${componentName}__loading-animation`}></div>
                    </div>
                </div>
            )}
            {!distributorCardLoading && distributorInfo && (
                <div className={`${componentName}__distributor-card-content`}>
                    <div className={`${componentName}__distributor-card-header`}>
                        {!userLocation && <div className={`${componentName}__distributor-card-text`}>{i18n('Find your nearest distributor')}</div>}
                        {userLocation && <div className={`${componentName}__distributor-card-text-custom`}>{i18n('Contact your distributor in {0}').replace('{0}', userLocation)}</div>}
                        <a className={`${componentName}__distributor-card-location-link`} href={PARTNER_LOCATOR_URL}>{i18n('Change location')}</a>
                    </div>
                    <div className={`${componentName}__divider`}></div>
                    {distributorInfo.map((distributor) => (
                        <div className={`${componentName}__distributor-card-partner-container`}>
                            <div className={`${componentName}__distributor-card-partner`}>
                                <div className={`${componentName}__distributor-card-partner-content`}>
                                    <a className={`${componentName}__distributor-card-partner-link`} href={distributor.url}>
                                        {distributor.image && 
                                            <><div className={`${componentName}__distributor-card-icon`}>
                                                <img className={`${componentName}__distributor-card-icon-img`} src={distributor.image} alt={distributor.partnerName} />
                                            </div>
                                            <div className={`${componentName}__distributor-card-partner-type`}>{distributor.distributorName}</div></>
                                        }
                                        {!distributor.image && <div className={`${componentName}__distributor-card-partner-text`}>{distributor.partnerName}</div>}
                                    </a>
                                    <div className={`${componentName}__distributor-card-actions`}>
                                        <div className={`${componentName}__distributor-card-actions-email`}
                                            tabIndex={0}
                                            data-email={distributor.partnerEmail}
                                            data-name={distributor.partnerName}
                                            data-apr-code={distributor.aprCode}
                                            data-partner-type={distributor.partnerType}
                                            data-address={distributor.partnerAddress}
                                            onClick={LS.openGatedForm}>
                                        </div>
                                        <div className={`${componentName}__distributor-card-actions-phone`} tabIndex={0} onClick={() => openContactDialog(distributor)}>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={`${componentName}__divider`}></div>
                        </div>
                    ))}
                    <div className={`${componentName}__distributor-card-link`}>
                        <a href={PARTNER_LOCATOR_URL}>
                            {i18n('Find a partner')}
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" aria-hidden="true">    <path d="M12.446 7.514l5.474 8.88-5.455 8.063a.8.8 0 1 0 1.325.897l5.745-8.491a.799.799 0 0 0 .018-.868l-5.745-9.32a.8.8 0 0 0-1.362.839z"></path></svg>
                        </a>
                    </div>
                </div>
            )}
        </div>
    );
}

export default DistributorCard;